<div class="flex min-h-[calc(100vh-48px)] flex-col gap-5 bg-light-color px-6 py-6 font-base text-dark-color">
  <header
    class="flex flex-col gap-4 rounded-2xl bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-6 text-light-color shadow-[0_14px_40px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-light-color/80">Clinicorp</p>
      <h1 class="text-2xl font-semibold leading-tight">Integração Clinicorp</h1>
      <p class="max-w-3xl text-sm text-light-color/90">
        Espaço inicial para configurarmos a jornada de integrações com a Clinicorp.
        Use essa tela para validar permissões e organizar os próximos passos.
      </p>
    </div>
    <div class="inline-flex items-center gap-2 rounded-full bg-[rgba(255,255,255,0.14)] px-3 py-2 text-sm">
      <mat-icon>science</mat-icon>
      <span>Primeira versão</span>
    </div>
  </header>

  <section
    class="flex flex-col gap-3 rounded-xl border border-border-color bg-white px-5 py-5 text-dark-color shadow-[0_12px_36px_var(--box-shadow-color)] md:flex-row md:items-start md:justify-between md:gap-6">
    <div class="flex flex-col gap-2">
      <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Clínicas</p>
      <h2 class="text-lg font-semibold text-dark-color">Cadastre e gerencie as integrações</h2>
      <p class="text-sm text-dark-color/70">
        Mantenha a lista de clínicas sempre atualizada e use os atalhos para editar ou remover rapidamente.
      </p>
    </div>
    <button
      type="button"
      class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-3 text-sm font-semibold text-white shadow-md transition hover:bg-primary-hover"
      (click)="handleCadastrarClinica()">
      <mat-icon>add</mat-icon>
      Cadastrar nova clínica
    </button>
  </section>

  <section class="flex flex-col gap-3">
    <article
      class="w-full rounded-xl border border-border-color bg-white px-5 py-4 text-dark-color shadow-[0_12px_40px_var(--box-shadow-color)]"
      *ngFor="let clinica of clinicas; trackBy: trackByNome"
      (click)="abrirDetalhesClinica(clinica)">
      <div class="flex items-center justify-between gap-3">
        <h3 class="text-lg font-semibold leading-tight">{{ clinica.nomeClinica }}</h3>
        <div class="flex items-center gap-2">
          <button
            type="button"
            class="flex h-10 w-10 items-center justify-center rounded-lg border border-border-color bg-white text-dark-color transition hover:border-primary-color hover:text-primary-color"
            aria-label="Excluir clínica"
            (click)="$event.stopPropagation()">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <p class="mt-2 text-sm text-dark-color/70">
        Hora de execução: {{ clinica.timeExecution || '—' }} | Status: {{ clinica.ativo ? 'Ativo' : 'Inativo' }}
      </p>
    </article>

    <div
      class="flex items-center gap-3 rounded-xl border border-dashed border-border-color bg-white px-4 py-4 text-dark-color/80"
      *ngIf="clinicas.length === 0">
      <mat-icon class="text-primary-color">info</mat-icon>
      <div class="flex flex-col">
        <p class="m-0 text-sm font-semibold text-dark-color">Nenhuma clínica cadastrada.</p>
        <span class="text-sm">Clique em "Cadastrar nova clínica" para começar.</span>
      </div>
    </div>
  </section>

  <div
    class="fixed inset-0 z-30 flex items-center justify-center bg-black/50 px-4"
    *ngIf="exibirModalCadastro">
    <div class="w-full max-w-3xl max-h-[90vh] overflow-y-auto rounded-xl bg-white p-6 shadow-2xl">
      <div class="flex items-center justify-between border-b border-border-color pb-4">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Cadastro Clinicorp</p>
          <h3 class="text-lg font-semibold text-dark-color">Nova clínica</h3>
        </div>
        <div class="flex items-center gap-2">
          <button
            type="button"
            aria-label="Ver variáveis"
            class="flex h-10 w-10 items-center justify-center rounded-full bg-light-color text-dark-color transition hover:bg-primary-color hover:text-white"
            (click)="abrirModalVariaveis($event)">
            <mat-icon>info</mat-icon>
          </button>
          <button
            type="button"
            class="text-dark-color/70 transition hover:text-dark-color"
            (click)="fecharModalCadastro()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <form
        class="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2"
        [ngClass]="loadingBusinessIdCadastro ? 'opacity-60 pointer-events-none' : ''"
        [formGroup]="cadastroClinicaForm"
        (ngSubmit)="submitCadastroClinica()">
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Subscribe ID</label>
          <input class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="subscribeId" placeholder="Identificador de assinatura" />
          <div *ngIf="loadingBusinessIdCadastro" class="flex items-center gap-2 text-xs text-dark-color/70">
            <span class="h-3 w-3 animate-spin rounded-full border-2 border-dark-color/30 border-t-dark-color"></span>
            Buscando Business ID...
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Token</label>
          <input class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="token" placeholder="Token de autenticação" />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Business ID</label>
          <input type="number" min="0" step="1" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="businessId" placeholder="Identificador do negócio" />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Nome da clínica</label>
          <input class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="nomeClinica" placeholder="Ex: Clínica Horizonte" />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Soma Dia</label>
          <input class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="somaDia" placeholder="Ex: 1" />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Mensagem Aniversário</label>
          <textarea rows="2" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color resize-y" formControlName="mensagemAniversario" placeholder="Mensagem para aniversariantes"></textarea>
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Mensagem Lembrete</label>
          <textarea rows="2" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color resize-y" formControlName="mensagemLembrete" placeholder="Mensagem de lembrete"></textarea>
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Mensagem Confirmação</label>
          <textarea rows="2" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color resize-y" formControlName="mensagemConfirmacao" placeholder="Mensagem de confirmação"></textarea>
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Horário de Execução</label>
          <input
            type="time"
            step="60"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="timeExecution"
            placeholder="Ex: 12:30"
            (change)="onTimeExecutionChange($event, cadastroClinicaForm)"
            (blur)="onTimeExecutionChange($event, cadastroClinicaForm)"
          />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Host</label>
          <input class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="host" placeholder="Host da integração" />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Queue ID</label>
          <input type="number" min="0" step="1" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="queueId" placeholder="Identificador da fila" />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">API Key</label>
          <input class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="apiKey" placeholder="Chave da API" />
        </div>
        <div class="flex items-center gap-2">
          <input type="checkbox" id="ativo" formControlName="ativo" class="h-4 w-4 rounded border border-border-color text-primary-color focus:ring-primary-color" />
          <label for="ativo" class="text-sm text-dark-color">Ativo</label>
        </div>

        <div class="col-span-1 md:col-span-2 mt-2 flex justify-end gap-2">
          <button type="button" class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color" (click)="fecharModalCadastro()">
            Cancelar
          </button>
          <button
            type="submit"
            class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-70"
            [disabled]="loadingSubmit || loadingBusinessIdCadastro">
            {{ loadingSubmit ? 'Salvando...' : 'Salvar clínica' }}
          </button>
        </div>
      </form>
    </div>
  </div>

  <app-alert></app-alert>

  <div
    class="fixed inset-0 z-40 flex items-center justify-center bg-black/50 px-4"
    *ngIf="exibirModalVariaveis">
    <div class="w-full max-w-lg rounded-xl bg-white p-5 shadow-2xl">
      <div class="flex items-center justify-between border-b border-border-color pb-3">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Variáveis disponíveis</p>
          <h3 class="text-lg font-semibold text-dark-color">Use nas mensagens</h3>
        </div>
        <button type="button" class="text-dark-color/70 transition hover:text-dark-color" (click)="fecharModalVariaveis()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <div class="mt-4 flex flex-col gap-2">
        <p class="text-sm text-dark-color/70">Clique em uma variável para copiar para a área de transferência.</p>
        <div class="flex flex-col divide-y divide-border-color rounded-lg border border-border-color">
          <button
            *ngFor="let variavel of variaveisDisponiveis"
            type="button"
            class="flex items-center justify-between gap-3 px-3 py-3 text-left transition hover:bg-light-color"
            (click)="copiarVariavel(variavel.chave, $event)">
            <div class="flex flex-col">
              <span class="text-sm font-semibold text-dark-color">{{ variavel.chave }}</span>
              <span class="text-xs text-dark-color/70">{{ variavel.descricao }}</span>
            </div>
            <mat-icon class="text-primary-color">content_copy</mat-icon>
          </button>
        </div>
      </div>
      <div class="mt-4 flex justify-end">
        <button type="button" class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover" (click)="fecharModalVariaveis()">
          Fechar
        </button>
      </div>
    </div>
  </div>

  <div
    class="fixed inset-0 z-30 flex items-center justify-center bg-black/50 px-4"
    *ngIf="exibirModalDetalhe">
    <div class="w-full max-w-3xl max-h-[90vh] overflow-y-auto rounded-xl bg-white p-6 shadow-2xl">
      <div class="flex items-center justify-between border-b border-border-color pb-4">
        <div>
          <p class="text-xs uppercase tracking-[0.12em] text-primary-color">Detalhes da Clínica</p>
          <h3 class="text-lg font-semibold text-dark-color">{{ clinicaSelecionada?.nomeClinica }}</h3>
        </div>
        <div class="flex items-center gap-2">
          <button
            type="button"
            aria-label="Ver variáveis"
            class="flex h-10 w-10 items-center justify-center rounded-full bg-light-color text-dark-color transition hover:bg-primary-color hover:text-white"
            (click)="abrirModalVariaveis($event)">
            <mat-icon>info</mat-icon>
          </button>
          <button
            type="button"
            class="text-dark-color/70 transition hover:text-dark-color"
            (click)="fecharModalDetalhe()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <form
        class="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2"
        [ngClass]="loadingBusinessIdEdicao ? 'opacity-60 pointer-events-none' : ''"
        [formGroup]="edicaoClinicaForm"
        (ngSubmit)="submitAtualizarClinica()">
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Subscribe ID</label>
          <input class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="subscribeId" placeholder="Identificador de assinatura" />
          <div *ngIf="loadingBusinessIdEdicao" class="flex items-center gap-2 text-xs text-dark-color/70">
            <span class="h-3 w-3 animate-spin rounded-full border-2 border-dark-color/30 border-t-dark-color"></span>
            Buscando Business ID...
          </div>
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Token</label>
          <input class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="token" placeholder="Token de autenticação" />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Business ID</label>
          <input type="number" min="0" step="1" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="businessId" placeholder="Identificador do negócio" />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Nome da clínica</label>
          <input class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="nomeClinica" placeholder="Ex: Clínica Horizonte" />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Soma Dia</label>
          <input class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="somaDia" placeholder="Ex: 1" />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Mensagem Aniversário</label>
          <textarea rows="2" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color resize-y" formControlName="mensagemAniversario" placeholder="Mensagem para aniversariantes"></textarea>
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Mensagem Lembrete</label>
          <textarea rows="2" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color resize-y" formControlName="mensagemLembrete" placeholder="Mensagem de lembrete"></textarea>
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Mensagem Confirmação</label>
          <textarea rows="2" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color resize-y" formControlName="mensagemConfirmacao" placeholder="Mensagem de confirmação"></textarea>
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Horário de Execução</label>
          <input
            type="time"
            step="60"
            class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color"
            formControlName="timeExecution"
            placeholder="Ex: 12:30"
            (change)="onTimeExecutionChange($event, edicaoClinicaForm)"
            (blur)="onTimeExecutionChange($event, edicaoClinicaForm)"
          />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Host</label>
          <input class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="host" placeholder="Host da integração" />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">Queue ID</label>
          <input type="number" min="0" step="1" class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="queueId" placeholder="Identificador da fila" />
        </div>
        <div class="flex flex-col gap-2">
          <label class="text-sm text-dark-color">API Key</label>
          <input class="rounded-base border border-border-color px-3 py-2 text-sm outline-none focus:border-primary-color" formControlName="apiKey" placeholder="Chave da API" />
        </div>
        <div class="flex items-center gap-2">
          <input type="checkbox" id="ativo-edicao" formControlName="ativo" class="h-4 w-4 rounded border border-border-color text-primary-color focus:ring-primary-color" />
          <label for="ativo-edicao" class="text-sm text-dark-color">Ativo</label>
        </div>

        <div class="col-span-1 md:col-span-2 mt-2 flex justify-end gap-2">
          <button type="button" class="rounded-base border border-border-color bg-dark-color px-4 py-2 text-sm text-white transition hover:border-primary-color" (click)="fecharModalDetalhe()">
            Fechar
          </button>
          <button
            type="submit"
            class="rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white transition hover:bg-primary-hover disabled:cursor-not-allowed disabled:opacity-70"
            [disabled]="loadingSubmit || loadingBusinessIdEdicao">
            {{ loadingSubmit ? 'Atualizando...' : 'Atualizar clínica' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
